import Vue from "vue";
import * as vant from "vant";
import "vant/lib/index.css";
// 自动注册所有组件
Object.keys(vant).forEach((key) => {
  const component = vant[key];
  if (component.install) {
    Vue.use(component);
  }
});
